import { useEffect } from 'react';
import { showError } from '@utils';

export const useEbikeErrors = ({
  ebikeResponse,
  ebikeEnumsResponse,
  ebikeProvidersResponse,
  ebikeModelsResponse,
  ebikesBySkuResponse,
}) => {
  useEffect(() => {
    const errors = [
      ebikeResponse.error,
      ebikeEnumsResponse.error,
      ebikeProvidersResponse.error,
      ebikeModelsResponse.error,
      ebikesBySkuResponse.error,
    ].filter(Boolean);

    errors.forEach(showError);
  }, [
    ebikeResponse?.error,
    ebikeEnumsResponse?.error,
    ebikeProvidersResponse?.error,
    ebikeModelsResponse?.error,
    ebikesBySkuResponse?.error,
  ]);
};
